import getAPIUrl from '../../config';
import { getApi } from '../../utils/apiCalls';
import removeFalsyValues from '../../utils/customMethods';
import { AdminsApiProps } from './types';

const getAdmins = async (data?: AdminsApiProps): Promise<Error | any> => {
    try {
        const result = getApi(
            `${getAPIUrl()}/admins/allAdmins`,
            data
                ? removeFalsyValues({
                      size: data.size,
                      page: data.currentPage,
                      sort: data.sort,
                      order: data.order,
                      name: data.searchText,
                      roles: data.selectedRole,
                      additionPeriod: data.selectedPeriod,
                      isActive: data.selectedStatus && data.selectedStatus === 'active',
                  })
                : undefined,
        );
        return result;
    } catch (error: unknown) {
        const err = error as Error;
        return err;
    }
};

export default getAdmins;
